import dayjs from "dayjs";
import { STATES } from "../oems/helper";

export const venueOptions = [
  {
  value: "SIMPSON_STC",
  label: "SIMPSON_STC"
  },
  {
  value: "OEM_PLANT",
  label: "OEM_PLANT"
  },
  {
  value: "DEALER_POINT",
  label: "DEALER_POINT"
  }];


 export const specialTrainingOptions = [
  {
    value: 'SPECIAL_TRAINING',
    label: 'Special Training'
    },
    {
    value: 'PRODUCT_TRAINING',
    label: 'Product Training'
    },
 ];
 export const trainingModeOptions = [
  {
    value: 'ONLINE',
    label: 'ONLINE'
    },
    {
    value: 'HANDSON',
    label: 'HANDSON'
    },
    {
    value: 'ONSITE',
    label: 'ONSITE'
    }
 ]

export const getEnrollmentFormRow1 = () => [
    {
      name: "oemName",
      type: "text",
      label: "OEM Name",
      placeholder: "Enter oem name",
      required: true,
    },
    {
      name: "courseDesired",
      type: "text",
      label: "Course Desired",
      placeholder: "SJ3259",
      required: true,
    },
    {
        name: "trainingMode",
        type: "autocomplete",
        options: trainingModeOptions,
        label: "Training Mode",
        placeholder: "Hands on",
        required: true,
    }
]

export const getEnrollmentFormRow2 = (startDate, endDate) => {
  const parseDate = (dateString) => {
    if (!dateString) return ""; // Handle undefined/null cases
    const [month, day, year] = dateString.split("/").map(Number); // Split and convert to numbers
    return `${day}/${month}/${year}`; // Convert to ISO string (YYYY-MM-DD)
  };

  return [
    {
      name: "courseStartDate",
      type: "datePicker",
      label: "From",
      placeholder: "Select Start Date",
      required: true,
      value: parseDate(startDate), // Parse and format start date
      minDate:dayjs(),
      disabled:true
    },
    {
      name: "courseEndDate",
      type: "datePicker",
      label: "To",
      placeholder: "Select End Date",
      required: true,
      value: parseDate(endDate), // Parse and format end date
      minDate:dayjs(),
      disabled:true
    },
    {
      name: "specialTraining",
      type: "autocomplete",
      options: specialTrainingOptions,
      label: "Training Type",
      placeholder: "Training Type",
      required: true,
    }
  ];
};

export const getEnrollmentFormRow3 = () =>[
    {
        name: "participantsCount",
        type: "text",
        label: "No. of Participants",
        placeholder: "123456",
        required: true,
    },
    {
        name: "venue",
        type: "autocomplete",
        options: venueOptions,
        label: "Venue",
        placeholder: "Dealer point",
        required: true,
    },
    {
        name: "dealerName",
        type: "text",
        label: "Dealer Name",
        placeholder: "Mahalakshmi Tractors",
        required: true,
    }
];

export const getEnrollmentFormRow4 = () =>[
    {
        name: "address",
        type: "text",
        label: "Address",
        placeholder: "Enter Address",
        required: true,
    },
    {
        name: "trainingLocation",
        type: "text",
        label: "Location",
        placeholder: "Enter Location",
        required: true,
    },
    {
        name: "state",
        type: "autocomplete",
        options: STATES,
        label: "State",
        placeholder: "Select State",
        required: true,
    }
];

export const getEnrollmentFormRequestRow1 = () => [
    {
      name: "model",
      type: "text",
      label: "Model",
      placeholder: "Enter Model",
      required: true,
    },
    {
      name: "oemName",
      type: "text",
      label: "OEM Name",
      placeholder: "Enter oem name",
      required: true,
    },
    {
      name: "courseDesired",
      type: "text",
      label: "Course Desired",
      placeholder: "SJ3259",
      required: true,
    }  
]

export const getEnrollmentFormRequestRow2 = (startDate, endDate) => {
  const parseDate = (dateString) => {
    if (!dateString) return ""; // Handle undefined/null cases
    const [month, day, year] = dateString.split("/").map(Number); // Split and convert to numbers
    return `${day}/${month}/${year}`; // Convert to ISO string (YYYY-MM-DD)
  };

  return [
    {
      name: "trainingMode",
      type: "autocomplete",
      options: trainingModeOptions,
      label: "Training Mode",
      placeholder: "Hands on",
      required: true,
  },
    {
      name: "courseStartDate",
      type: "datePicker",
      label: "Course Start Date",
      placeholder: "Select Start Date",
      required: true,
      value: parseDate(startDate), // Parse and format start date
      minDate:dayjs()
    },
    {
      name: "courseEndDate",
      type: "datePicker",
      label: "Course End Date",
      placeholder: "Select End Date",
      required: true,
      value: parseDate(endDate), // Parse and format end date
      minDate:dayjs()
    }    
  ];
};

export const getEnrollmentFormRequestRow3 = () =>[
  {
    name: "specialTraining",
    type: "autocomplete",
    options: specialTrainingOptions,
    label: "Training Type",
    placeholder: "Training Type",
    required: true,
  },
    {
        name: "participantsCount",
        type: "text",
        label: "No. of Participants",
        placeholder: "123456",
        required: true,
    },
    {
        name: "venue",
        type: "autocomplete",
        options: venueOptions,
        label: "Venue",
        placeholder: "Dealer point",
        required: true,
    }
];

export const getEnrollmentFormRequestRow4 = () =>[
  {
    name: "dealerName",
    type: "text",
    label: "Dealer Name",
    placeholder: "Mahalakshmi Tractors",
    required: true,
  },
    {
        name: "address",
        type: "text",
        label: "Address",
        placeholder: "Enter Address",
        required: true,
    },
    {
        name: "trainingLocation",
        type: "text",
        label: "Location",
        placeholder: "Enter Location",
        required: true,
    },
    {
        name: "state",
        type: "autocomplete",
        options: STATES,
        label: "State",
        placeholder: "Select State",
        required: true,
    }
];

export const updateParticipantDetailsForm = () =>[
  {
    name: "name",
    type: "text",
    label: "Candidate Name"
  },
  {
      name: "age",
      type: "text",
      label: "Age"
  },
  {
      label: "Qualification",
      name: "qualification",
      type: "text",
  },
  {
    label: "No. of years Experience",
    name: "experienceInYears",
    type: "text"
  },
  {
    label: "Designation",
    name: "designation",
    type: "text"
  }, 
  {
    label: "Photo",
    id: "photo",
    render: (data) => {
       return(
        <img
            className="mc-image"
            src={data.photo.split('?')[0]}
            alt={data.name}
      />
      )
    }
}
];


export const trainingCertificateList = {
    HeaderConfig: [
        {
          label: "S l No.",
          id: "serialNumber"
        },
        {
          label: "Name of the Organization",
          id: "oemName"
        },
        {
          label: "Name of the Candidate",
          id: "candidateName"
        },
        {
          label: "Age",
          id: "age"
        },
        {
          label: "Qualification",
          id: "qualification"
        },
        {
          label: "No. of years Experience",
          id: "yearsOfExperience"
        },
        {
          label: "Designation",
          id: "designation"
        },      
        {
          label: "Course Desired",
          id: "courseDesired",
        },      
        {
          label: "Course Duration",
          id: "courseDuration",
        },      
        {
            label: "Venue",
            id: "venue"          
        },
        {
            label: "Certificate",
            id: "candidatePhoto"
        }   
      ]
}

export const trainingRequestedList = {
    HeaderConfig: [
        {
          label: "S l No.",
          id: "serialNumber"
        },
        {
          label: "Organization",
          id: "oem"
        },
        {
          label: "No. of the Candidates",
          id: "numberOfParticipants"
        },
        {
          label: "Course Desired",
          id: "course",
        },      
        {
          label: "Course Start Date",
          id: "courseStartDate",
        },
        {
          label: "Course End Date",
          id: "courseEndDate",
        },
        {
          label: "No. of days",
          id: "daysCount",
        },                
        {
            label: "Venue",
            id: "venue"          
        },
        {
            label: "Dealer Name",
            id: "dealerName"
        },  
        {
            label: "State",
            id: "state"
        }, 
        {
            label: "Address",
            id: "address"
        },  
        {
            label: "Location",
            id: "city"
        }, 
        {
            label: "Remarks",
            id: "remarks"
        }   
      ]
};

export const trainingRequestedParticipantList = {
  HeaderConfig: [
      {
        label: "S l No.",
        id: "serialNumber"
      },
      {
        label: "Name of the Candidate",
        id: "name"
      },
      {
        label: "Age",
        id: "age"
      },
      {
        label: "Qualification",
        id: "qualification"
      },
      {
        label: "No. of years Experience",
        id: "experienceInYears"
      },
      {
        label: "Designation",
        id: "designation"
      },      
      {
          label: "Photo",
          id: "photo",
          render: (data) => {
            return(
              <img
                  className="mc-image"
                  src={data.photo.split('?')[0]}
                  alt={data.name}
            />
            )
          }
      }
    ]
}

export const participantsCardLabelMapper = [
  {label: 'Course Name',value:'courseName'},
  {label: 'No. of Participants',value:'numberOfParticipants'},
  {label: 'Training Mode',value:'trainingMode'},
  {label: 'Course Start Date',value:'courseStartDate'},
  {label: 'Course End Date',value:'courseEndDate'},
  {label: 'No. of Days',value:'daysCount'},
  {label: 'Venue',value:'venue'},
  {label: 'Dealer Name',value:'dealerName'},
  {label: 'State',value:'state'},
  {label: 'Address',value:'address'},
  {label: 'City',value:'city'},
  {label: 'Remarks',value:'remarks'} 
];

export const trainingRequestListDummyData = [{
    "_id": "b91f0d8c-ff4b-4c4d-96f8-bf4f8c0a00c4",
    "oem": "OEM Corporation",
    "course": "Advanced Engineering",
    "trainingMode": "ONSITE",
    /* "courseDuration": {
      "startDate": "2024-11-01T00:00:00.000Z",
      "endDate": "2024-11-05T00:00:00.000Z"
    }, */
    "courseDuration": '2Hrs',
    "courseTiming": {
      "startTime": "09:00",
      "endTime": "17:00"
    },
    "numberOfParticipants": 25,
    "participants": [
      {
        "name": "John Doe",
        "age": 35,
        "qualification": "Bachelor's in Engineering",
        "experienceInYears": 10,
        "designation": "Senior Engineer",
        "photo": "https://example.com/photos/johndoe.jpg"
      },
      {
        "name": "Jane Smith",
        "age": 29,
        "qualification": "Master's in Engineering",
        "experienceInYears": 5,
        "designation": "Project Lead",
        "photo": "https://example.com/photos/janesmith.jpg"
      }
    ],
    "venue": "OEM PLANT",
    "dealerName": "Dealer XYZ",
   /*  "address": {
      "line1": "123 Industrial Drive",
      "city": "Springfield",
      "state": "Illinois"
    }, */
    "address":"Chennai",
    "approved": "PENDING",
    "approvedBy": "user123",
    "createdAt": "2024-10-14T12:00:00.000Z",
    "updatedAt": "2024-10-14T12:00:00.000Z",
    "daysCount":'1',
    "serialNumber":'1'
  }]

